import { render } from "./noteSettingsNew.vue?vue&type=template&id=417899b4&scoped=true"
import script from "./noteSettingsNew.vue?vue&type=script&lang=js"
export * from "./noteSettingsNew.vue?vue&type=script&lang=js"

import "./noteSettingsNew.vue?vue&type=style&index=0&id=417899b4&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417899b4"]])

export default __exports__